import { WhitelabelBackendConfig } from '@zignaly-open/ps2-definitions';

export const imageOrFile = (v: string | File, suffix: string) =>
  typeof v === 'string' ? v + '/' + suffix : URL.createObjectURL(v);

export function fallbackForOauthProviders(
  providers?: WhitelabelBackendConfig['oauthProviders'],
): WhitelabelBackendConfig['oauthProviders'] {
  const result = providers ? [...providers] : [];
  if (!result.find((x) => x.name === 'google')) {
    result.push({
      name: 'google',
      client_id: '',
      client_secret: '',
      redirect_uri: '',
    });
  }
  return result;
}
